import React from "react";
import { Carousel } from "../../components/Carousel/Carousel";
import "./home-page.scss";

export const HomePage: React.FC = () => (
  <div id="home">
    <Carousel />
  </div>
);
